"use client";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Package,
  BarChart3,
  Boxes,
  AlertTriangle,
  RotateCcw,
  TrendingUp
} from "lucide-react";
import styles from "./AnalyticsSidebar.module.css";

const AnalyticsSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const analyticsOptions = [
    {
      category: "Descriptive Analytics",
      options: [
        { name: "Drug Stock Level", path: "/analytics/drug-stock-level", icon: Package },
        { name: "Top Selling Medications", path: "/analytics/top-selling-medications", icon: BarChart3 },
        { name: "Inventory Levels", path: "/analytics/inventory-levels", icon: Boxes },
        { name: "Expired Stock", path: "/analytics/expired-stock", icon: AlertTriangle },
        { name: "Return Rate", path: "/analytics/return-rate", icon: RotateCcw },
      ]
    },
    {
      category: "Predictive Analytics",
      options: [
        { name: "Demand Forecasting", path: "/analytics/demand-forecasting", icon: TrendingUp },
      ]
    }
  ];

  const getFilteredOptions = () => {
    const currentPath = location.pathname;

    if (currentPath.includes('/analytics/drug-stock-level') ||
      currentPath.includes('/analytics/top-selling-medications') ||
      currentPath.includes('/analytics/inventory-levels') ||
      currentPath.includes('/analytics/expired-stock') ||
      currentPath.includes('/analytics/return-rate')) {
      return [analyticsOptions[0]];
    }

    if (currentPath.includes('/analytics/demand-forecasting')) {
      return [analyticsOptions[1]];
    }

    return analyticsOptions;
  };

  const filteredOptions = getFilteredOptions();

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className={`${styles.sidebar} ${styles.analyticsSidebar}`}>
      <div className={styles.sidebarContent}>
        {filteredOptions.map((category, categoryIndex) => (
          <div key={categoryIndex} className={styles.categorySection}>
            <div className={styles.optionsList}>
              {category.options.map((option, optionIndex) => {
                const IconComponent = option.icon;
                return (
                  <div key={optionIndex} className={styles.optionItem}>
                    <button
                      className={`${styles.optionButton} ${isActive(option.path) ? styles.active : ''}`}
                      onClick={() => handleNavigation(option.path)}
                    >
                      <IconComponent className={styles.optionIcon} size={18} />
                      <span className={styles.optionText}>{option.name}</span>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnalyticsSidebar;
